import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import HeaderEpics from './Header/epics'
import { fetchIncidentError, fetchIncidentSuccess } from './actions'
import { FILTER_CHANGE, INCIDENT_REQUEST_ASYNC, PAGINATE_CHANGE } from './constants'

const fetchIncidentEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(INCIDENT_REQUEST_ASYNC.INITIATE, PAGINATE_CHANGE, FILTER_CHANGE)
    .mergeMap((action) =>
      api.resolutionCenter
        .getAtoIncident(
          action.payload.incidentId || store.getState().resolutioncenter.atoIncident.incidentId,
          store.getState().resolutioncenter.atoIncident.page,
          {
            ...store.getState().resolutioncenter.atoIncident.allFilters,
            locationFilter:
              store.getState().resolutioncenter.atoIncident.allFilters?.locationFilter.length > 0
                ? store
                    .getState()
                    .resolutioncenter.atoIncident.allFilters?.locationFilter?.map((e) => escape(e))
                    .join('~')
                : '',
          }
        )
        .map((response) => fetchIncidentSuccess(response))
        .catch((error) => Observable.of(epicsErrorHandler(fetchIncidentError, error)))
        .takeUntil(action$.ofType(INCIDENT_REQUEST_ASYNC.CANCEL))
    )

export default combineEpics(fetchIncidentEpic, HeaderEpics)
